export default __webpack_public_path__ + "static/media/arrow-right-circle-line.2dee1eb8.svg";